let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ajw0S")).then(() => parcelRequire('9OxUo'));